import React, { Suspense } from "react";
import { Outlet, useParams } from "react-router-dom";

import { useGroupLookup } from "@/api/groups";
import MissingIndicator from "@/components/missing-indicator";
import { Layout } from "@/components/ui";
import { useAuth } from "@/contexts/auth/useAuth";
import { GroupContext } from "@/contexts/group-context";
import ColumnLoading from "@/features/ui/components/column-loading";
import CtaBanner from "@/features/ui/components/cta-banner";
import { SignUpPanel } from "@/features/ui/util/async-components";

const GroupGuard = () => {
  const { groupSlug } = useParams();
  const { group, isLoading } = useGroupLookup(groupSlug);
  const { currentAccount } = useAuth();

  if (isLoading)
    return (
      <>
        <ColumnLoading />

        <Layout.Aside />
      </>
    );

  if (!group)
    return (
      <>
        <Layout.Main>
          <MissingIndicator />

          {!currentAccount && (
            <Suspense fallback={null}>
              <CtaBanner key="cta-banner" />
            </Suspense>
          )}
        </Layout.Main>

        <Layout.Aside>
          {!currentAccount && (
            <Suspense fallback={null}>
              <SignUpPanel key="sign-up-panel" />
            </Suspense>
          )}
        </Layout.Aside>
      </>
    );

  return (
    <GroupContext.Provider value={{ group, groupId: group.id }}>
      <Outlet />
    </GroupContext.Provider>
  );
};

export default GroupGuard;
